/*
 * Instant winkelwagen voor Bellacombe (Horizon), 2026-10-12. Zelfde patroon als Vesnia (11-10).
 *
 * Probleem: Horizon opent de lade direct bij "Add to cart", maar vult hem pas na /cart/add.js (~650 ms)
 * en daarna nog /cart.json (~150 ms). Tot dan staat er een lege lade met spinner of de oude inhoud.
 *
 * Oplossing: bij het event shopify:cart:lines-update (vóór de lade opengaat) tekenen we meteen de
 * eindtoestand: productregel, kop met teller, staffelkorting, Delivery, totaal, checkoutknop en de
 * teller bij het tasje. Bouwstenen komen uit snippets/mb-instant-cart.liquid (dezelfde markup als de
 * lade). De rekensom komt uit een /cart.js-momentopname. Als de server antwoordt, morpht Horizon de
 * echte HTML eroverheen: die is gelijk, dus de klant ziet niets wisselen.
 *
 * Terugval (gewoon het oude gedrag) als de momentopname ontbreekt of niet klopt met ons kortingsmodel,
 * bij kortingscodes, regelkortingen, line item properties, selling plans, andere valuta, of als het
 * event niet van het hoofdproduct komt.
 *
 * Staffels: automatische kortingen "Buy 2/3/4 - Extra 10/15/20% off" (Amount off order, hele mand; 28-10: "Buy 5+ - Extra
 * 25% off" uit, dus max. 20%,
 * mand). Shopify rondt de korting naar beneden af op de cent. Wijzig je de kortingen in de admin,
 * pas dan MB_TIERS aan (anders valt de instant-weergave automatisch terug op het oude gedrag).
 */
(function () {
  if (window.__mbInstantCart) return;
  window.__mbInstantCart = true;

  var MB_TIERS = [
    { min: 4, pct: 20, title: 'Buy 4 - Extra 20% off' },
    { min: 3, pct: 15, title: 'Buy 3 - Extra 15% off' },
    { min: 2, pct: 10, title: 'Buy 2 - Extra 10% off' }
  ];
  var EVENT = 'shopify:cart:lines-update';

  var dataEl = document.getElementById('mb-ic-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  // Geldformaat afleiden uit een server-gerenderd voorbeeld (123456 centen): "£1,234.56", "€1.234,56", "1 234,56 €" ...
  var SAMPLE = /1(\D?)234(\D)56/;
  var MS = SAMPLE.exec(D.money), MC = SAMPLE.exec(D.moneyCur);
  if (!MS || !MC) return;

  var routes = (window.Theme && window.Theme.routes) || {};
  var cartJsUrl = (routes.cart_url || '/cart') + '.js';
  var snap = null;
  var snapBusy = false;
  var pending = null;

  function refreshSnap() {
    snapBusy = true;
    return fetch(cartJsUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { snap = c; })
      .catch(function () { snap = null; })
      .finally(function () { snapBusy = false; });
  }

  function money(cents, withCurrency) {
    var m = withCurrency ? MC : MS;
    var s = (Math.abs(cents) / 100).toFixed(2).split('.');
    var amount = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, m[1]) + m[2] + s[1];
    return (withCurrency ? D.moneyCur : D.money).replace(m[0], amount);
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function tpl(id) {
    var t = document.getElementById(id);
    return t ? t.innerHTML : '';
  }
  function fill(html, map) {
    return html.replace(/%%([A-Z0-9]+)%%/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; });
  }

  /* Kortingsmodel: staffel op het totale aantal, percentage van het subtotaal, naar beneden afgerond. */
  function model(lines) {
    var subtotal = 0, qty = 0;
    lines.forEach(function (l) { subtotal += l.price * l.quantity; qty += l.quantity; });
    var tier = null;
    for (var i = 0; i < MB_TIERS.length; i++) {
      if (qty >= MB_TIERS[i].min) { tier = MB_TIERS[i]; break; }
    }
    var disc = tier ? Math.floor(subtotal * tier.pct / 100) : 0;
    return { subtotal: subtotal, qty: qty, tier: tier, disc: disc, total: subtotal - disc };
  }

  /* Klopt de momentopname met ons model? Zo niet: geen instant-weergave (veilig terugvallen). */
  function snapUsable(c) {
    if (!c || !c.items || c.currency !== D.currency) return false;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      if (it.original_price !== it.final_price) return false;
      if (it.line_level_discount_allocations && it.line_level_discount_allocations.length) return false;
      if (it.properties && Object.keys(it.properties).length) return false;
      if (it.selling_plan_allocation) return false;
    }
    var m = model(c.items.map(function (it) { return { price: it.original_price, quantity: it.quantity }; }));
    var apps = c.cart_level_discount_applications || [];
    if (m.tier) {
      if (apps.length !== 1 || apps[0].title !== m.tier.title || apps[0].total_allocated_amount !== m.disc) return false;
    } else if (apps.length) {
      return false;
    }
    return c.total_price === m.total && c.item_count === m.qty;
  }

  function rowHtml(v, variantId, qty, line) {
    // BD (Barbara Dever 1:1): oude regelprijs + "You save" in de prijskolom
    var cmpLine = v.cmp && v.cmp > v.price ? v.cmp * qty : 0;
    var html = fill(tpl('mb-ic-row'), {
      KEY: 'mb-pending-' + variantId,
      MEDIA: v.media,
      URL: v.url,
      OPTS: v.opts,
      UNIT: v.unit,
      RM: v.rm,
      LINE: String(line),
      LINEPRICE: money(v.price * qty, D.itemsCur),
      BDOLD: cmpLine ? '<s class="bd-ci-old">' + money(cmpLine, D.itemsCur) + '</s>' : '',
      BDBASE: String(cmpLine || v.price * qty),
      BDSAVE: cmpLine ? fill(tpl('mb-ic-bdsave'), { AMOUNT: money(cmpLine - v.price * qty, D.itemsCur) }) : ''
    });
    // De aantalkiezer is server-side gerenderd voor de standaardvariant met aantal 1, regel 1.
    return html
      .replace(/data-variant-id="\d+"/, 'data-variant-id="' + variantId + '"')
      .replace(/value="1"(\s+)data-cart-quantity="1"/, 'value="' + qty + '"$1data-cart-quantity="' + qty + '"')
      .replace(/data-cart-line="1"/, 'data-cart-line="' + line + '"');
  }

  /* Staffelbalk (mi-cart-tiers): bestaande balk ter plekke bijwerken (vulling schuift vloeiend door),
     anders de server-gerenderde balk voor dit aantal neerzetten. */
  function paintTiers(inner, qty) {
    var html = tpl('mb-ic-tiers-' + Math.min(Math.max(qty, 1), 5)).trim();
    if (!html) return;
    var cur = inner.querySelector('.cart-drawer__content > .mi-tiers');
    if (!cur) {
      var items = inner.querySelector('.cart-drawer__content > .cart-drawer__items');
      if (items) items.insertAdjacentHTML('beforebegin', html);
      return;
    }
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var nw = tmp.firstElementChild;
    var msg = cur.querySelector('.mi-tiers__msg'), nmsg = nw.querySelector('.mi-tiers__msg');
    var tr = cur.querySelector('.mi-tiers__track'), ntr = nw.querySelector('.mi-tiers__track');
    var fl = cur.querySelector('.mi-tiers__fill'), nfl = nw.querySelector('.mi-tiers__fill');
    var mk = cur.querySelectorAll('.mi-tiers__marker'), nmk = nw.querySelectorAll('.mi-tiers__marker');
    if (!msg || !nmsg || !tr || !ntr || !fl || !nfl || mk.length !== nmk.length) {
      cur.outerHTML = html;
      return;
    }
    cur.className = nw.className;
    msg.outerHTML = nmsg.outerHTML;
    tr.setAttribute('aria-valuenow', ntr.getAttribute('aria-valuenow'));
    fl.setAttribute('style', nfl.getAttribute('style'));
    for (var i = 0; i < mk.length; i++) mk[i].className = nmk[i].className;
  }

  function paintSummary(inner, m) {
    var orig = inner.querySelector('.cart-totals__original-container');
    if (orig) {
      if (m.tier) {
        var lbl = orig.querySelector('.mi-cs-label');
        var li = fill(tpl('mb-ic-discount'), {
          FIRST: lbl ? lbl.outerHTML : '<span class="mi-cs-label">Discounts</span>',
          TITLE: esc(m.tier.title),
          AMOUNT: money(m.disc, false)
        });
        orig.innerHTML = tpl('mb-ic-discounts').replace('></ul>', '>' + li + '</ul>');
      } else {
        orig.innerHTML = '';
      }
    }
    var totalText = money(m.total, D.totalCur);
    var total = inner.querySelector('[ref="cartTotal"]');
    if (total) {
      total.setAttribute('value', totalText);
      total.textContent = totalText;
    }
    var cap = inner.querySelector('.cart-items__table caption span');
    if (cap) cap.textContent = money(m.total, true);
    var count = inner.querySelector('[ref="cartItemCount"]');
    if (count) count.textContent = String(m.qty);
    var badge = inner.querySelector('.mb-cd-head .theme-drawer__badge');
    if (badge) {
      badge.textContent = String(m.qty);
      badge.classList.remove('visually-hidden');
      if (m.qty <= 99) badge.setAttribute('data-maintain-ratio', ''); else badge.removeAttribute('data-maintain-ratio');
      var sr = badge.nextElementSibling;
      if (sr && sr.classList.contains('visually-hidden')) sr.textContent = sr.textContent.replace(/\d+\s*$/, String(m.qty));
    }
    var checkout = inner.querySelector('#checkout');
    if (checkout) checkout.removeAttribute('disabled');
    // BD: Discount-regel = som van de basisbedragen (oude prijs x aantal) min het totaal
    var bdDisc = inner.querySelector('.bd-cs-discount');
    if (bdDisc) {
      var base = 0;
      inner.querySelectorAll('.cart-items__table-row .bd-ci-base').forEach(function (e) { base += Number(e.getAttribute('data-v')) || 0; });
      // Willa (AU/US, 2026-10-27): alleen de stapel-/bundelkorting; de doorstreepbesparing staat per regel als "You save"
      var dv = document.body.classList.contains('wl') ? m.disc : base - m.total;
      bdDisc.hidden = !(dv > 0);
      var bdv = bdDisc.querySelector('.bd-cs-discount__value');
      if (bdv && dv > 0) bdv.textContent = '-' + money(dv, false);
      var chip = bdDisc.querySelector('.bd-cs-chip'), pct = bdDisc.querySelector('.bd-cs-chip__pct');
      if (chip) chip.hidden = !m.tier;
      if (pct && m.tier) pct.textContent = m.tier.pct + '%';
    }
    // BD: bedrag in de knop "Check order • £X"
    var coTotal = inner.querySelector('.bd-co-total');
    if (coTotal) coTotal.textContent = money(m.total, false);
  }

  /* Italië (2026-10-28, winkelwagen zoals Vesnia): per regel doorstreepprijs x aantal + regelprijs na de staffelkorting,
     en onderaan "Risparmi" = doorstreepprijzen min het totaal. De regels in de lade staan in dezelfde volgorde als `lines`. */
  function paintIt(inner, lines, m, rowsArg) {
    var rows = rowsArg || inner.querySelectorAll('.cart-items__table tbody tr.cart-items__table-row');
    var pct = m.tier ? m.tier.pct : 0, base = 0;
    var isIt = /^it/i.test(document.documentElement.lang || '');
    // 30-10: verdeling zoals Shopify (gemeten op 44 winkelwagens): korting x regel / subtotaal naar beneden, de restcenten
    // één voor één vanaf de bovenste regel. (Vroeger: laatste regel kreeg de rest, soms 1 cent naast de server.)
    var shares = lines.map(function (l) { return m.subtotal ? Math.floor(m.disc * l.price * l.quantity / m.subtotal) : 0; });
    var rest = m.disc - shares.reduce(function (a, b) { return a + b; }, 0);
    for (var k = 0; rest > 0 && lines.length; k++, rest--) shares[k % lines.length]++;
    lines.forEach(function (l, i) {
      var sub = l.price * l.quantity;
      var share = shares[i];
      var el = rows[i] && rows[i].querySelector('.it-ci-price');
      var cmp = el ? Number(el.getAttribute('data-cmp')) || l.price : l.price;
      var old = Math.max(cmp, l.price) * l.quantity;
      base += old;
      if (!el) return;
      var now = el.querySelector('.it-ci-now'), s = el.querySelector('.it-ci-old');
      if (now) now.textContent = money(sub - share, D.itemsCur);
      if (s) { s.textContent = money(old, D.itemsCur); s.hidden = !(old > sub - share); }
      // UK (29-10): "Save X%" zoals op de productpagina (doorstreepprijs t.o.v. de productprijs, zonder staffel)
      var sv = el.querySelector('.it-ci-save');
      if (sv) { var sp = cmp > l.price ? Math.round((cmp - l.price) * 100 / cmp) : 0; sv.textContent = (isIt ? 'Risparmia ' : 'Save ') + sp + '%'; sv.hidden = !(sp > 0); }
    });
    var save = inner.querySelector('.it-cs-save');
    if (save) {
      // 29-10 UK "Discounts" + Italië "Sconti" = alleen de stapelbundelkorting (de doorstreepbesparing staat per regel als Save/Risparmia %)
      var dv = m.disc;
      save.hidden = !(dv > 0);
      var val = save.querySelector('.it-cs-save__val');
      if (val && dv > 0) val.textContent = '-' + money(dv, false);
      var chip = save.querySelector('.it-cs-chip'), cp = save.querySelector('.it-cs-chip__pct');
      if (chip) chip.hidden = !pct;
      // UK (28-10): labeltje = kortingsnaam ("Buy 2 - Extra 10% off"), Italië = "10%"
      if (cp && pct) cp.textContent = cp.hasAttribute('data-title') ? m.tier.title : pct + '%';
    }
  }

  /* 30-10 (Remco: "het zelfde met bellacombe als je 1extra toevoegd in de cart update prijs niet in cart", "het moet allemaal
     soepel snel clean werken zonder bugs of foute berekeningen"): +/- en verwijderen in de lade (UK/IT) meteen tekenen:
     regelprijzen met staffelkorting, Save %, staffelbalk, Discounts, totaal, checkoutknop, tellers. Prijzen per variant uit de
     momentopname (/cart.js); de server bevestigt daarna met dezelfde bedragen. Iets onbekends (kortingscode, properties,
     AU/US-opmaak) = niets tekenen, dan gaat het zoals vroeger. Aangeroepen vanuit component-cart-items.js. */
  window.mbBellaPaint = function () {
    try {
      if (!D.it || !snapUsable(snap)) return false;
      var drawer = document.querySelector('theme-drawer#cart-drawer');
      var inner = drawer && drawer.querySelector('.cart-drawer__inner');
      if (!inner || inner.querySelector('tr[data-key^="mb-pending"]')) return false;
      var price = {};
      snap.items.forEach(function (it) { price[String(it.variant_id)] = it.original_price; });
      var rows = Array.prototype.filter.call(inner.querySelectorAll('.cart-items__table tbody tr.cart-items__table-row'), function (r) {
        return !r.classList.contains('removing') && !r.hasAttribute('data-mb-removed');
      });
      var lines = [];
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (r.classList.contains('cart-items__nested-line')) return false;
        var qs = r.querySelector('[data-variant-id]'), inp = r.querySelector('input[name="updates[]"]');
        if (!qs || !inp) return false;
        var vid = qs.getAttribute('data-variant-id'), q = parseInt(inp.value, 10);
        if (isNaN(q) || q < 0 || price[vid] == null) return false;
        if (q > 0) lines.push({ id: vid, price: price[vid], quantity: q, row: r });
      }
      if (!lines.length) return false; // lege lade: dat tekent Horizon zelf
      var mm = model(lines);
      paintTiers(inner, mm.qty);
      paintSummary(inner, mm);
      paintIt(inner, lines, mm, lines.map(function (l) { return l.row; }));
      var icon = document.querySelector('cart-icon');
      if (icon && typeof icon.renderCartBubble === 'function') (icon.__mbOrigRender || icon.renderCartBubble).call(icon, mm.qty, false);
      return true;
    } catch (e) {
      return false;
    }
  };

  /* Teller bij het tasje: nu zetten, en de tweede (identieke) update van het thema niet nog eens laten "poppen". */
  function bumpCartIcon(count) {
    var icon = document.querySelector('cart-icon');
    if (!icon || typeof icon.renderCartBubble !== 'function') return;
    var original = icon.__mbOrigRender || icon.renderCartBubble;
    icon.__mbOrigRender = original;
    icon.__mbOptCount = count;
    icon.renderCartBubble = function (itemCount, animate) {
      if (icon.__mbOptCount === itemCount) {
        icon.__mbOptCount = null;
        return original(itemCount, false);
      }
      return original(itemCount, animate);
    };
    original(count, true);
  }

  function onLinesUpdate(event) {
    if (event.action !== 'add' || event.context !== 'product') return;
    var form = event.target && event.target.closest ? event.target.closest('product-form-component') : null;
    if (!form || String(form.dataset.productId) !== String(D.productId)) return;
    if (form.closest('dialog')) return;
    if (form.querySelector('[name^="properties["], [name="selling_plan"]')) return;
    if (!event.lines || event.lines.length !== 1) return;

    var variantId = String(event.lines[0].merchandiseId).replace(/\D/g, '');
    var addQty = Number(event.lines[0].quantity) || 1;
    var v = D.variants[variantId];
    if (!v || v.plan || snapBusy || !snapUsable(snap)) return;

    var drawer = document.querySelector('theme-drawer#cart-drawer');
    var inner = drawer && drawer.querySelector('.cart-drawer__inner');
    var cic = inner && inner.querySelector('cart-items-component');
    if (!inner || !cic) return;
    var domRows = inner.querySelectorAll('.cart-items__table tbody tr.cart-items__table-row');
    if (domRows.length !== snap.items.length) return; // lade loopt niet gelijk met de momentopname

    // Nieuwe regels in de momentopname: zelfde variant = aantal omhoog, anders bovenaan erbij (zoals Shopify).
    var lines = snap.items.map(function (it) { return { id: String(it.variant_id), price: it.original_price, quantity: it.quantity }; });
    var existing = null;
    for (var i = 0; i < lines.length; i++) { if (lines[i].id === variantId) { existing = i; break; } }
    if (existing !== null) lines[existing].quantity += addQty;
    else lines.unshift({ id: variantId, price: v.price, quantity: addQty });
    var m = model(lines);
    // Andere taal dan Engels (bv. Italië): kortingsnamen kunnen vertaald zijn. Alleen instant met korting als
    // de momentopname al een korting met onze (Engelse) naam toont; anders het gewone gedrag.
    // Italië (28-10): de staffelkortingen heten daar ook "Buy 2 - Extra 10% off" enz. (gecontroleerd), dus ook instant bij 1 -> 2
    if (m.tier && D.locale !== 'en' && !D.it) {
      var known = (snap.cart_level_discount_applications || []).some(function (a) {
        return MB_TIERS.some(function (t) { return t.title === a.title; });
      });
      if (!known) return;
    }

    var backup = { head: null, cic: cic.innerHTML, empty: inner.classList.contains('cart-drawer--empty') };
    var head = inner.querySelector(':scope > .mb-cd-head');
    if (head) backup.head = head.outerHTML;

    try {
      if (!snap.items.length) {
        // Lege lade: kop en inhoud van een gevulde lade neerzetten.
        if (head) head.outerHTML = fill(tpl('mb-ic-head'), { COUNT: String(m.qty), RATIO: m.qty <= 99 ? 'data-maintain-ratio' : '' });
        cic.innerHTML = fill(tpl('mb-ic-content'), {
          COUNT: String(m.qty),
          TOTALCUR: money(m.total, true),
          TIERS: tpl('mb-ic-tiers-' + Math.min(m.qty, 5)).trim()
        });
        inner.classList.remove('cart-drawer--empty');
      }
      var tbody = inner.querySelector('.cart-items__table tbody');
      if (!tbody) throw new Error('geen tbody');
      if (existing !== null) {
        var row = tbody.querySelectorAll('tr.cart-items__table-row')[existing];
        var input = row && row.querySelector('input[name="updates[]"]');
        var price = row && row.querySelector('.cart-items__price text-component');
        if (!input || !price) throw new Error('regel niet gevonden');
        input.value = String(lines[existing].quantity);
        input.setAttribute('value', String(lines[existing].quantity));
        input.setAttribute('data-cart-quantity', String(lines[existing].quantity));
        var lp = money(lines[existing].price * lines[existing].quantity, D.itemsCur);
        price.setAttribute('value', lp);
        price.textContent = lp;
      } else {
        tbody.insertAdjacentHTML('afterbegin', rowHtml(v, variantId, addQty, 1));
      }
      paintTiers(inner, m.qty);
      paintSummary(inner, m);
      if (D.it) paintIt(inner, lines, m);
    } catch (err) {
      restore(inner, backup);
      return;
    }

    // Tot het serverantwoord: regels niet bedienbaar (regelnummers kloppen nog niet).
    var cartForm = inner.querySelector('#cart-form');
    if (cartForm) cartForm.setAttribute('inert', '');
    bumpCartIcon(m.qty);

    var state = { wantCheckout: false };
    pending = state;
    // Wachten tot Horizon de serverversie heeft gemorpht (geen "mb-pending"-regel meer), max ~2 s.
    // Bewust geen requestAnimationFrame: die staat stil in een verborgen tabblad.
    var settled = function () {
      return new Promise(function (r) {
        var tries = 0;
        (function check() {
          var d = document.querySelector('theme-drawer#cart-drawer');
          var busy = d && d.querySelector('tr[data-key^="mb-pending"]');
          if (!busy || ++tries > 40) setTimeout(r, 30);
          else setTimeout(check, 50);
        })();
      });
    };

    (event.promise || Promise.reject(new Error('geen promise')))
      .then(function (res) {
        var didError = res && res.detail && res.detail.didError;
        if (didError) {
          restore(inner, backup);
          var td = document.querySelector('theme-drawer#cart-drawer');
          if (td && typeof td.close === 'function') td.close();
          var icon = document.querySelector('cart-icon');
          if (icon) icon.__mbOptCount = null;
        }
        return settled().then(function () { return didError; });
      })
      .then(function (didError) {
        var f = document.querySelector('theme-drawer#cart-drawer #cart-form');
        if (f) f.removeAttribute('inert');
        if (pending === state) pending = null;
        if (!didError && state.wantCheckout) {
          var b = document.querySelector('theme-drawer#cart-drawer #checkout');
          if (b) b.click();
        }
      })
      .catch(function () {
        restore(inner, backup);
        if (pending === state) pending = null;
      });
  }

  function restore(inner, backup) {
    try {
      var cic = inner.querySelector('cart-items-component');
      var head = inner.querySelector(':scope > .mb-cd-head');
      if (backup.head && head) head.outerHTML = backup.head;
      if (cic) cic.innerHTML = backup.cic;
      inner.classList.toggle('cart-drawer--empty', backup.empty);
    } catch (e) { /* de server-render van Horizon herstelt de lade alsnog */ }
  }

  // Checkout tijdens het toevoegen: vasthouden en daarna alsnog uitvoeren (nooit zonder het nieuwe product).
  document.addEventListener('click', function (e) {
    if (!pending) return;
    var b = e.target && e.target.closest ? e.target.closest('theme-drawer#cart-drawer #checkout') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    pending.wantCheckout = true;
  }, true);

  // Vóór de lade-component (die luistert in de bubbelfase op document) zodat de lade gevuld opengaat.
  document.addEventListener(EVENT, onLinesUpdate, true);

  // Na elke winkelwagenwijziging (ook +/- en verwijderen in de lade) de momentopname verversen.
  document.addEventListener(EVENT, function (event) {
    if (!event.promise) return;
    snapBusy = true;
    event.promise.then(refreshSnap, refreshSnap);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshSnap(); });

  refreshSnap();
})();
